// src/pages/LoginPage.jsx
import React, { useState, useEffect } from "react";
import {
  Container,
  Box,
  Typography,
  TextField,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

function LoginPage() {
  const navigate = useNavigate();
  const API_BASE =
  process.env.REACT_APP_API_BASE || "http://localhost:5000";


  // 🔐 Redirect if already logged in
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user?.id) {
      navigate("/app", { replace: true });
    }
  }, [navigate]);

  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });

  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleLogin = async (e) => {
    e.preventDefault();
    setMessage("");
    setLoading(true);

    try {
      const response = await fetch(`${API_BASE}/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

if (response.ok && data.success) {
  // 🔥 CLEAR ALL MOMENT STATE
  Object.keys(sessionStorage).forEach((key) => {
    if (
      key.startsWith("moment_") ||
      key === "moment_suppressed"
    ) {
      sessionStorage.removeItem(key);
    }
  });

  // ✅ Save user
  localStorage.setItem("user", JSON.stringify(data.user));

  // 🔑 Fresh login flag
  sessionStorage.setItem("just_logged_in", "1");

  setMessage(`✅ Welcome back, ${data.user.username}`);

  setTimeout(() => {
    navigate("/app", { replace: true });
  }, 700);
}


       else {
        setMessage(`❌ ${data.message || "Invalid credentials"}`);
      }
    } catch (err) {
      console.error("Login error:", err);
      setMessage("❌ Failed to connect to server");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container
      maxWidth="sm"
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
      }}
    >
      <Box
        component="form"
        onSubmit={handleLogin}
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <Typography variant="h4" fontWeight={700} align="center">
          Welcome back
        </Typography>

        <Typography
          variant="body2"
          color="text.secondary"
          align="center"
          sx={{ mb: 2 }}
        >
          Sign in to continue to LifeShot
        </Typography>

        <TextField
          label="Username"
          name="username"
          value={formData.username}
          onChange={handleChange}
          required
        />

        <TextField
          label="Password"
          name="password"
          type="password"
          value={formData.password}
          onChange={handleChange}
          required
        />

        <Button
          type="submit"
          variant="contained"
          color="primary"
          disabled={loading}
        >
          {loading ? "Signing in..." : "Login"}
        </Button>

       <Button
            variant="text"
            onClick={() => navigate("/forgot-password")}
            sx={{
              color: "primary.main",
              fontWeight: 600,
              opacity: 1,
              textTransform: "none",
              "&:hover": {
                backgroundColor: "transparent",
                textDecoration: "underline",
              },
            }}
          >
            Forgot Password?
          </Button>


        {message && (
          <Typography
            sx={{ mt: 1 }}
            color={message.startsWith("✅") ? "success.main" : "error"}
          >
            {message}
          </Typography>
        )}

        <Typography variant="body2" align="center" sx={{ mt: 2 }}>
          Don’t have an account?{" "}
          <span
            style={{ color: "#16A34A", cursor: "pointer", fontWeight: 600 }}
            onClick={() => navigate("/signup")}
          >
            Sign up
          </span>
        </Typography>
      </Box>
    </Container>
  );
}

export default LoginPage;
